var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"music",on:{"click":_vm.handleMusic}},[_c('Cover',{staticClass:"music-cover",attrs:{"music":_vm.musicInfo,"current-time":_vm.currentTime}}),_c('Info',{staticClass:"music-info",attrs:{"music":_vm.musicInfo}}),_c('PlayIcon',{staticClass:"music-icon",attrs:{"music":_vm.musicInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }